import React from 'react';

/**
 * Small idle equalizer for the Home "Voice Journal" card. Pure CSS-keyframe
 * bars — no audio, no canvas. Decorative only (aria-hidden). Disabled under
 * prefers-reduced-motion, where it settles into a static silhouette.
 */
export default function AnimatedWaveform({ bars = 5, color = 'currentColor', height = 20, className = '' }) {
  const resting = [0.4, 0.75, 1, 0.6, 0.35]; // silhouette when motion is reduced
  return (
    <div className={`flex items-center gap-[3px] ${className}`} aria-hidden="true">
      <style>{`
        @keyframes mwWaveBar { 0%, 100% { transform: scaleY(0.3); } 50% { transform: scaleY(1); } }
        @media (prefers-reduced-motion: reduce) {
          .mw-wave-bar { animation: none !important; }
        }
      `}</style>
      {Array.from({ length: bars }).map((_, i) => (
        <span
          key={i}
          className="mw-wave-bar inline-block w-[3px] rounded-full origin-center"
          style={{
            height,
            backgroundColor: color,
            transform: `scaleY(${resting[i % resting.length]})`,
            animation: `mwWaveBar 1.1s ease-in-out ${i * 0.12}s infinite`,
          }}
        />
      ))}
    </div>
  );
}
